import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import RouteListener from './RouteListener';
import AssetListSlat from './AssetListSlat';

require('../../css/components/AssetList.scss');

'use strict';

export default class AssignedAssetList extends React.Component {
    constructor(props) {
        super(props);
        this.state = { encounter: null, loaded: false, loading: false, cacheKey: this.props.cacheKey };
        this.onNewCurrentAsset = this.props.onNewCurrentAsset;
    }

    componentDidMount() {
        this.loadData();
    }

    componentDidUpdate() {
        if (this.state.loaded && this.props.location && this.state.encounter && this.state.encounter.assignments) {
            this.findNextAsset(this.props.location, queryString.parse(this.props.location.hash), this.state.encounter, null, this.state.encounter.assignments, this.onNewCurrentAsset);
        }

        if (this.props.cacheKey !== this.state.cacheKey)
            this.loadData();
    }

    findNextAsset(location, urlHash, encounter, assignment, items, func) {
        var foundItem;
        var nextItem;

        for (var i = 0; i < items.length; i++) {
            var item = items[i];

            if (item.items) {
                assignment = item;
                var j = this.findNextAsset(location, urlHash, null, assignment, assignment.items);
                if (j !== -1) {
                    foundItem = assignment.items[j];
                    var nextIncompleteItem;

                    for (var k = 1; k <= assignment.items.length; k++) {
                        nextIncompleteItem = assignment.items[(j + k) % assignment.items.length];

                        if (k === 1)
                            nextItem = nextIncompleteItem;

                        if (nextIncompleteItem.progress < 1.0)
                            break;
                    }

                    if (k <= assignment.items.length)
                        nextItem = nextIncompleteItem;

                    break;
                }
            }
            else
                if ((this.props.location.pathname === item.asset.url) && (assignment.id === urlHash["assignmentId"]))
                    return i;
        }

        if (func) {
            if (foundItem) {
                func(location, foundItem.asset.asset, nextItem.asset, encounter, assignment, foundItem);
            }
        }
        else
            return -1;
    }

    loadData() {
        this.setState({
            loading: true
        });

        this.props.user.getAssignments(
            result => {
                this.setState({
                    loading: false,
                    loaded: true,
                    cacheKey: this.props.cacheKey,
                    encounter: result
                });
            },
            () => {
                this.setState({
                    loading: false,
                    reload: false,
                    cacheKey: this.props.cacheKey,
                    loaded: false
                });
            }
        );
    }

    renderItems(assignmentId, items, keyPrefix) {
        var assets = [];

        var urlHash = queryString.parse(this.props.location.hash);
        urlHash["assignmentId"] = assignmentId;

        for (var i in items) {
            var item = items[i];

            if (!item.displayAsComplete && item.progress > 0 && item.progress < 1.0)
                urlHash["bookmark"] = Math.round(item.progress * 100) / 100;
            else
                delete urlHash["bookmark"];

            assets.push(
                React.createElement(
                    AssetListSlat,
                    {
                        key: keyPrefix + i,
                        parentKey: keyPrefix + i,
                        asset: item.asset,
                        urlHash: "#" + queryString.stringify(urlHash),
                        useRouter: this.props.useRouter,
                        location: this.props.location,
                        overrideProgress: this.props.overrideProgress,
                        assignment: item,
                        assignmentId: assignmentId,
                        copy: this.props.copy
                    }
                ));
        }

        return assets;
    }

    renderAssignments() {
        if (this.state.loading)
            return this.props.copy.loading;

        if (this.state.loaded) {
            var assignments = this.state.encounter.assignments;
            var children = [];

            if (this.props.useRouter)
                children.push(
                    React.createElement(
                        Route,
                        {
                            key: "r",
                            path: '/',
                            component: RouteListener
                        },
                    )
                );

            var urlHash = queryString.parse(this.props.location.hash);
            var assignmentId = urlHash["assignmentId"];

            for (var a in assignments) {
                var assignment = assignments[a];

                if (!assignmentId || assignmentId === assignment.id)
                    children.push(
                        React.createElement(
                            'li',
                            { key: assignment.id, className: "listAssetSlat" },
                            React.createElement(
                                'div',
                                { key: assignment.id, className: "assignments" },
                                [
                                    React.createElement(
                                        'div',
                                        {
                                            key: "0",
                                            className: "d-flex"
                                        },
                                        [
                                            React.createElement(
                                                'div',
                                                {
                                                    key: "0",
                                                    style: { flexGrow: "1" },
                                                    "data-target": "#playlist-" + assignment.id,
                                                    onClick: (e) => {
                                                        $(e.target.dataset["target"]).collapse('toggle');
                                                        return false;
                                                    }
                                                },
                                                assignment.titleDx[this.props.languageCode] || assignment.titleDx["eng"]
                                            ),
                                            React.createElement(
                                                'div',
                                                {
                                                    key: "1",
                                                    className: "d-flex flex-column justify-content-center"
                                                },
                                                React.createElement(
                                                    'a',
                                                    {
                                                        className: "btn listAssetSlat__expand collapsed", href: "#", "data-toggle": "collapse", "data-target": "#playlist-" + assignment.playlistId, "aria-controls": "playlist-" + assignment.playlistId, "aria-expanded": false, title: "Click to show or hide"
                                                    }
                                                )
                                            )
                                        ]
                                    ),
                                    React.createElement(
                                        'div',
                                        { key: "1", id: "playlist-" + assignment.id, className: "collapse" },
                                        React.createElement(
                                            'ul',
                                            { className: "assetList" },
                                            this.renderItems(assignment.id, assignment.items, "a-" + a + "-")
                                        )
                                    )
                                ]
                            )
                        )
                    );
            }

            var ul = React.createElement(
                'ul',
                {
                    className: 'assetList'
                },
                children
            );

            if (this.props.useRouter)
                return React.createElement(
                    Router,
                    { },
                    ul
                );
            else
                return ul;
        }
    }

    render() {
        return React.createElement(
            'div',
            { className: "assignments" },
            [
                React.createElement(
                    'h2',
                    { key: "h" },
                    this.props.heading
                    ),
                this.renderAssignments()
            ]
        );
    }
}